import { createContext, useContext, useState, useCallback } from 'react'
import { getHasNewLikesAndMatches, markLikesSeen as markLikesSeenApi } from '../lib/likes'

const NewLikesContext = createContext()

export const useNewLikes = () => {
  const ctx = useContext(NewLikesContext)
  return ctx || { hasNewLikes: false, hasNewMatches: false, refresh: () => {}, markSeen: () => {} }
}

export const NewLikesProvider = ({ children }) => {
  const [hasNewLikes, setHasNewLikes] = useState(false)
  const [hasNewMatches, setHasNewMatches] = useState(false)

  const refresh = useCallback(async (userId) => {
    if (!userId) return
    const r = await getHasNewLikesAndMatches(userId)
    setHasNewLikes(r.hasNewLikes)
    setHasNewMatches(r.hasNewMatches)
  }, [])

  const markSeen = useCallback(async (userId) => {
    if (!userId) return
    await markLikesSeenApi(userId)
    setHasNewLikes(false)
    setHasNewMatches(false)
  }, [])

  return (
    <NewLikesContext.Provider
      value={{
        hasNewLikes,
        hasNewMatches,
        hasNew: hasNewLikes || hasNewMatches,
        refresh,
        markSeen
      }}
    >
      {children}
    </NewLikesContext.Provider>
  )
}
